"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCalculatedColumnWidth = void 0;
const getColumnWidth_1 = require("./getColumnWidth");
function withCalculatedColumnWidth(columns, bodyWidth) {
    let widthRemainder = bodyWidth;
    columns.forEach((config) => {
        widthRemainder = Math.max(widthRemainder - (0, getColumnWidth_1.getColumnWidth)(config), 0);
    });
    const flexColumns = columns
        .map((item, index) => Object.assign({}, item, { idx: index }))
        .filter((item) => item.width === undefined)
        .map((item) => { var _a; return Object.assign({}, item, { flex: (_a = item.flex) !== null && _a !== void 0 ? _a : 1 }); });
    const divider = flexColumns.reduce((acc, curr) => {
        return acc + curr.flex;
    }, 0);
    const flexSizeUnit = Math.floor(widthRemainder / divider);
    const columnsWithCalculatedWidth = columns.map((config, colIndex) => {
        const flexCol = flexColumns.find((value) => value.idx == colIndex);
        return Object.assign({}, config, {
            width: (0, getColumnWidth_1.getColumnWidth)(config) + (flexCol ? flexCol.flex * flexSizeUnit : 0)
        });
    });
    const widthSum = columnsWithCalculatedWidth.reduce((acc, curr) => {
        return acc + curr.width;
    }, 0) + 1;
    const widthDiff = bodyWidth - widthSum;
    if (widthDiff > 0 && flexColumns.length) {
        let columnIndexWithMaxFlex = 0;
        flexColumns.forEach((item, idx) => {
            if (item.flex >= flexColumns[columnIndexWithMaxFlex].flex) {
                columnIndexWithMaxFlex = idx;
            }
        });
        const originIndex = flexColumns[columnIndexWithMaxFlex].idx;
        columnsWithCalculatedWidth[originIndex].width =
            columnsWithCalculatedWidth[originIndex].width + widthDiff;
    }
    return columnsWithCalculatedWidth;
}
exports.withCalculatedColumnWidth = withCalculatedColumnWidth;
//# sourceMappingURL=withCalculatedColumnWidth.js.map